import { render, staticRenderFns } from "./FaultEventAlarmReject.vue?vue&type=template&id=12c3b054&scoped=true"
import script from "./FaultEventAlarmReject.vue?vue&type=script&lang=ts"
export * from "./FaultEventAlarmReject.vue?vue&type=script&lang=ts"
import style0 from "./FaultEventAlarmReject.vue?vue&type=style&index=0&id=12c3b054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3b054",
  null
  
)

export default component.exports